import { quickProperty, designToken } from '../component-tokens';
import { borderBase, focusState } from './common';
export const toolbarData = {
    name: 'toolbar',
    tag: 'chameleon-toolbar',
    reactImports: 'Toolbar, ToolbarButton',
    attributes: {
        display: quickProperty('inline-flex'),
    },
    children: [
        {
            name: 'button',
            attributes: Object.assign(Object.assign({}, borderBase), { 'box-sizing': quickProperty('border-box'), cursor: quickProperty('pointer'), height: quickProperty('28px'), display: quickProperty('flex'), outline: quickProperty('0'), color: designToken('text-02'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), 'border-color': designToken('toolbar-background-color'), 'background-color': designToken('toolbar-background-color'), position: quickProperty('relative') }),
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'border-color': designToken('toolbar-hover-background-color'),
                        'background-color': designToken('toolbar-hover-background-color'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, focusState),
                },
                {
                    name: 'active',
                    attributes: {
                        'border-color': designToken('toolbar-pressed-background-color'),
                        'background-color': designToken('toolbar-pressed-background-color'),
                        'box-shadow': quickProperty('none'),
                        color: designToken('text-06'),
                    },
                },
                {
                    name: 'disabled',
                    attributes: {
                        'pointer-events': quickProperty('none'),
                        'border-color': quickProperty('transparent'),
                        'background-color': designToken('toolbar-disabled-background-color'),
                        color: designToken('toolbar-disabled-icon-color'),
                    },
                },
            ],
        },
    ],
};
